import { changeCustomerSelectCustomerContainerStyles } from "@insite/content-library/Widgets/ChangeCustomer/ChangeCustomerSelectCustomerContainer";
import { buttonBaseStyles } from "@store/theme/mixins";
import { css } from "styled-components";

Object.assign(changeCustomerSelectCustomerContainerStyles, {
    ...changeCustomerSelectCustomerContainerStyles,
    cancelButton: {
        variant: "secondary",
        css: css`
            ${buttonBaseStyles("solid")}
            margin-right: 15px;
        `,
    },
});
